export const LICENSES_REDUCER_NAME = 'licenses'
export const LICENSES_LIST_REDUCER_NAME = 'licensesList'
export const LICENSES_NOTE_UPDATE_REDUCER_NAME = 'noteUpdate'
export const UPDATE_LICENSES_REDUCER_NAME = 'updateLicenses'
export const IMPORT_LICENSE_REDUCER_NAME = 'importLicense'
export const RECLAIM_LICENSE_REDUCER_NAME = 'reclaimLicense'
export const TRANSFER_LICENSE_REDUCER_NAME = 'transferLicense'
export const LICENSES_COLLAPSE_STATE_REDUCER_NAME = 'licensesCollapseState'

export const skuSortPriority = [
  'SSL-SUPERPROP-1YR', // premium 1 year super pro
  'SSL-PROP-1YR', // premium 1 year pro
  'SSL-SMRTP-1YR', // premium 1 year smart
  'SSL-S2EMBP-1YR', // premium 1 year s2/embedded
  'SSL-SUPERPROE-1YR', // essential 1 year super pro
  'SSL-PROE-1YR', // essential 1 year pro
  'SSL-SMRTE-1YR', // essential 1 year smart
  'SSL-S2EMBE-1YR', // essential 1 year s2/embedded
  'OSL-SUPERPRO10-00', // super pro 10.x runtime
  'OSL-PRO10-00', // pro 10.x runtime
  'OSL-SMRT10-00', // smart 10.x runtime
  'OSL-SUPERPRO10U-00', // super pro 10.x upgrade
  'OSL-PRO10U-00', // pro 10.x upgrade
  'OSL-SMRT10U-00', // smart 10.x upgrade
  'OSL-SUPERPRO9-00', // super pro 9.x runtime
  'OSL-PRO9-00', // pro 9.x runtime
  'OSL-SMRT9-00', // smart 9.x runtime
  'OSL-SUPERPRO9U-00', // super pro 9.x upgrade
  'OSL-PRO9U-00', // pro 9.x upgrade
  'OSL-SMRT9U-00', // smart 9.x upgrade
  'OSL-SMRTPREM-00', // premium smart features
  'Savant da Vinci Software - Premium Activation', // ???
  'SFL-ATVHOME-00', // home app for apple tv
  'SFL-ZOOM1-00', // zoom room
  'SFL-RING1-00', // ring
  'SFL-LEAP-00', // lutron leap
  'SFL-DEV1-00', // dev only, unlocks host dev api
  'OSL-SUPERPRO8-00', // super pro 8.x runtime
  'OSL-PRO8-00', // pro 8.x runtime
  'OSL-SMRT8-00', // smart 8.x runtime
  'OSL-SUPERPRO8U-00', // super pro 8.x upgrade
  'OSL-PRO8U-00', // pro 8.x upgrade
  'OSL-SMRT8U-00', // smart 8.x upgrade
]

export enum LICENSES_CODE_TYPES {
  available = 'available',
  used = 'used',
}
